import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="save-indicator"
export default class extends Controller {
  static targets = ["status"]
  static values = {
    savingText: { type: String, default: "🔄 Saving..." },
    savedText: { type: String, default: "✓ Saved" },
    errorText: { type: String, default: "✗ Not saved" }
  }

  connect() {
    this.activeSaves = 0
    this.hideTimeout = null

    // Listen for device check saving, saved, and error events
    this.boundHandleSaving = this.handleSaving.bind(this)
    this.boundHandleSaved = this.handleSaved.bind(this)
    this.boundHandleError = this.handleError.bind(this)

    document.addEventListener('device-check:saving', this.boundHandleSaving)
    document.addEventListener('device-check:saved', this.boundHandleSaved)
    document.addEventListener('device-check:error', this.boundHandleError)

    console.log('Save indicator controller connected')
  }

  disconnect() {
    document.removeEventListener('device-check:saving', this.boundHandleSaving)
    document.removeEventListener('device-check:saved', this.boundHandleSaved)
    document.removeEventListener('device-check:error', this.boundHandleError)

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  handleSaving(event) {
    this.activeSaves++
    console.log('Save started, active saves:', this.activeSaves)

    // Cancel any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    this.showSaving()
  }

  handleSaved(event) {
    this.activeSaves--
    console.log('Save completed, active saves:', this.activeSaves)

    // If all saves are complete, show "Saved" and schedule hide
    if (this.activeSaves <= 0) {
      this.activeSaves = 0
      this.showSaved()
    }
  }

  handleError(event) {
    this.activeSaves = 0
    console.log('Save failed, active saves:', this.activeSaves)

    this.showError()
  }

  showSaving() {
    this.statusTarget.textContent = this.savingTextValue
    this.statusTarget.classList.remove('hidden', 'bg-green-100', 'text-green-800', 'bg-red-100', 'text-red-800')
    this.statusTarget.classList.add('bg-blue-100', 'text-blue-800')
    this.statusTarget.style.opacity = '1'
  }

  showSaved() {
    console.log('Showing saved indicator')

    this.statusTarget.textContent = this.savedTextValue
    this.statusTarget.classList.remove('bg-blue-100', 'text-blue-800', 'bg-red-100', 'text-red-800')
    this.statusTarget.classList.add('bg-green-100', 'text-green-800')
    this.statusTarget.classList.remove('hidden')
    this.statusTarget.style.opacity = '1'

    // Hide it after 2 seconds with fade out
    this.hideTimeout = setTimeout(() => {
      this.statusTarget.style.opacity = '0'
      setTimeout(() => {
        this.statusTarget.classList.add('hidden')
        this.statusTarget.style.opacity = '1' // Reset for next time
      }, 300) // Wait for fade animation
    }, 2000)
  }

  showError() {
    console.log('Showing error indicator')

    // Cancel any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    this.statusTarget.textContent = this.errorTextValue
    this.statusTarget.classList.remove('hidden', 'bg-blue-100', 'text-blue-800', 'bg-green-100', 'text-green-800')
    this.statusTarget.classList.add('bg-red-100', 'text-red-800')
    this.statusTarget.style.opacity = '1'

    // Hide it after 4 seconds with fade out
    this.hideTimeout = setTimeout(() => {
      this.statusTarget.style.opacity = '0'
      setTimeout(() => {
        this.statusTarget.classList.add('hidden')
        this.statusTarget.style.opacity = '1'
      }, 300)
    }, 4000)
  }
}
